"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpError = exports.HttpError = exports.axiosErrorFields = void 0;
var tslib_1 = require("tslib");
var headers_1 = require("./headers");
exports.axiosErrorFields = [
    'code',
    'stack',
    'config',
    'request',
    'response',
    'toJSON',
    '__CANCEL__',
];
var HttpError = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(HttpError, _super);
    function HttpError(error) {
        var _this = _super.call(this, error.message) || this;
        _this.isWixHttpError = true;
        Object.setPrototypeOf(_this, HttpError.prototype);
        exports.axiosErrorFields.forEach(function (key) {
            // index is type checked, but converting into 'any' as suggested in Typescript issues.
            _this[key] = error[key];
        });
        return _this;
    }
    Object.defineProperty(HttpError.prototype, "requestId", {
        get: function () {
            return (0, headers_1.requestIdOrEmptyString)(this.response);
        },
        enumerable: false,
        configurable: true
    });
    return HttpError;
}(Error));
exports.HttpError = HttpError;
function createHttpError() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new (HttpError.bind.apply(HttpError, (0, tslib_1.__spreadArray)([void 0], args, false)))();
}
exports.createHttpError = createHttpError;
//# sourceMappingURL=error.js.map